import { motion } from 'framer-motion'
import styles from './Configurator.module.css'

interface ColorSwatchesProps {
  selected: string
  onSelect: (color: string) => void
}

const colors = [
  { id: 'red', label: 'Rojo', value: 'var(--color-cover-red)' },
  { id: 'yellow', label: 'Amarillo', value: 'var(--color-cover-yellow)' },
  { id: 'green', label: 'Verde', value: 'var(--color-cover-green)' },
  { id: 'blue', label: 'Azul', value: 'var(--color-cover-blue)' },
]

export function ColorSwatches({ selected, onSelect }: ColorSwatchesProps) {
  return (
    <div className={styles.swatchesContainer}>
      <span className={styles.swatchesLabel}>Color de Cubierta</span>
      <div className={styles.swatches}>
        {colors.map((color) => (
          <motion.button
            key={color.id}
            className={`${styles.swatch} ${selected === color.id ? styles.swatchSelected : ''}`}
            style={{ backgroundColor: color.value }}
            whileHover={{ scale: 1.15 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onSelect(color.id)}
            aria-label={`Seleccionar color ${color.label}`}
            aria-pressed={selected === color.id}
          />
        ))}
      </div>
    </div>
  )
}
